export const DRAWER_TYPES = {
  addWorklog: 'a',
  filters: 'f',
};
